import { useLingui } from '@lingui/react/macro'
import { notifications } from '@mantine/notifications'
import { trpc } from '../trpc'

export const userHooks = {
  useMe: () => trpc.user.me.useQuery(),
  useUpdate: () => {
    const { t } = useLingui()
    const utils = trpc.useUtils()
    return trpc.user.update.useMutation({
      onSuccess: () => {
        utils.user.me.invalidate()
        notifications.show({
          title: t`Information updated`,
          message: t`Information updated`,
          color: 'green',
        })
      },
      onError: (error) => {
        notifications.show({
          title: t`Error`,
          message: error.message || t`Failed to update information`,
          color: 'red',
        })
      },
    })
  },
  useUpdateMarketingConsent: () => {
    const { t } = useLingui()
    const utils = trpc.useUtils()
    return trpc.user.updateMarketingConsent.useMutation({
      onSuccess: () => {
        utils.user.me.invalidate()
      },
      onError: (error) => {
        notifications.show({
          title: t`Error`,
          message: error.message || t`Failed to update settings`,
          color: 'red',
        })
      },
    })
  },
}
